export default "__VITE_ASSET__eQhrQH2F__"